import { forwardRef } from 'react';
import { cx } from 'class-variance-authority';
import { BaseTypeMap, Component, ComponentProps } from '../types/Component';
import { Input } from '../Input';
import { Well } from '../Well';

type RadioGroupExpanderInputTypeMap = BaseTypeMap<
  'input',
  {
    label: string;
    transparent?: boolean;
  }
>;

export type RadioGroupExpanderInputProps =
  ComponentProps<RadioGroupExpanderInputTypeMap>;

export const RadioGroupExpanderInput: Component<RadioGroupExpanderInputTypeMap> =
  forwardRef(function RadioGroupRadioGroupExpanderInputInput(
    { children, className, label, name, value, checked, transparent, ...rest },
    ref
  ) {
    return (
      <Well className={cx(className)} transparent={transparent || !checked}>
        <Input
          ref={ref}
          type="radio"
          name={name || ''}
          label={label}
          checked={checked}
          value={value}
          {...rest}
        />
        {checked ? children : null}
      </Well>
    );
  });
